/**
 * @param {string} locale
 */
export const isRtl = (locale) =>
  !!['ar-AE', 'ar-EG', 'ar-SA', 'ar-LB', 'ar-MA', 'he-IL'].find(
    (item) => item === locale
  );
